export default {
  placeholder: 'Kunden auswählen',
};
